import type { StoreApi } from 'zustand';

import type { ActiveThreadStore } from '../active-thread-store';
import type { CommentsApi } from '../comments-api-context';
import type { CommentsSubject } from '../subject/comments-subject';

export type CommentsGroupMemberRole = 'parent' | 'task';

export type CommentsGroupMemberRegistration = {
    readonly api: CommentsApi;
    readonly label: string;
    readonly memberId: string;
    readonly role: CommentsGroupMemberRole;
    readonly subject: CommentsSubject;
    // The member tile's own active-thread store. The group comment tile hosts the member's
    // pending anchored thread, so it needs to read and clear that state where it actually
    // lives — in the tile that owns the anchor — instead of duplicating it.
    readonly threadStore: StoreApi<ActiveThreadStore>;
};

export type CommentsGroupMember = CommentsGroupMemberRegistration & {
    readonly registrationOrder: number;
};

export type CommentsGroupMemberRef = {
    readonly kind: CommentsSubject['kind'];
    readonly label: string;
    readonly memberId: string;
    readonly role: CommentsGroupMemberRole;
    readonly subjectId: string;
};

export const toCommentsGroupMemberRef = ({
    label,
    memberId,
    role,
    subject,
}: CommentsGroupMember): CommentsGroupMemberRef => ({
    kind: subject.kind,
    label,
    memberId,
    role,
    subjectId: subject.subjectId,
});

export const contributesToStream = (member: CommentsGroupMember): boolean => member.subject.persistence !== 'unsaved';

export const commentsGroupMemberIdFor = (subject: Pick<CommentsSubject, 'kind' | 'subjectId'>): string =>
    `${subject.kind}:${subject.subjectId}`;
